import React, { useState } from 'react'
import '../App.css'
import axios from 'axios'
import { SERVER_URI } from '../utility/config'

function CarPriorityGroupCreatedMessage(props) {
  window.setTimeout(function () {
    // Move to a new location
    props.handleClose()
  }, 1700)
  return (
    <div>
      <h2 className='message_title'>Uusi ryhmä lisätty</h2>
    </div>
  )
}

function AddCarPriorityGroup(props) {
  const [show, setShow] = useState(false)
  const [userData, setUserData] = useState({
    priorityGroup: '',
    delayTime: '',
  })
  let storage = window.localStorage
  let userToken = storage.getItem('admin_token')

  //Look at this closer
  const onChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
  }

  // Submit
  const doSubmit = async (e) => {
    e.preventDefault()
    const dataToServer = {
      ...userData,
      priorityGroup: userData.priorityGroup,
      delayTime: Number(userData.delayTime),
    }
    const dataToReducer = {
      ...userData,
      group: userData.priorityGroup,
      delayTime: Number(userData.delayTime),
    }

    try {
      await axios.post(`${SERVER_URI}/set_car_priority_times/`, dataToServer, {
        headers: { Authorization: `Token ${userToken}` },
      })
      props.dispatch({
        type: 'ADD_CAR_PRIORITY_GROUP',
        data: { newGroup: dataToReducer },
      })
      setShow(!show)
    } catch (e) {
      console.log('Error in adding car priority group', e)
    }
  }
  return (
    <div className='popUp_card'>
      <div className='popup-box'>
        <div className='box'>
          <span className='close-icon' onClick={props.handleClose}>
            x
          </span>
          {!show && (
            <div>
              <h2 className='popUp_title'>Lisää ryhmä ja viivästys</h2>
              <form className='group_form' onSubmit={(e) => doSubmit(e)}>
                <label className='label_add' htmlFor='priorityGroup'>
                  Ryhmän nimi:
                </label>
                <input
                  type='text'
                  id='priorityGroup'
                  name='priorityGroup'
                  onChange={onChange}
                  placeholder='Nimi'
                  required
                ></input>
                <span className='validity'></span>{' '}
                <br className='desktop-break' />
                <label className='label_add' htmlFor='delayTime'>
                  Aika minuutteina:
                </label>
                <input
                  type='number'
                  id='delayTime'
                  name='delayTime'
                  placeholder='Aika'
                  onChange={onChange}
                  required
                ></input>
                min<span className='validity'></span>
                <br className='desktop-break' />
                <input type='submit' id='gradient_Button' value='Lisää ryhmä' />
              </form>
            </div>
          )}
          {show && (
            <CarPriorityGroupCreatedMessage handleClose={props.handleClose} />
          )}
        </div>
      </div>
    </div>
  )
}

export default AddCarPriorityGroup
